var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 13.3929H1.33333C0.873096 13.3929 0.5 13.766 0.5 14.2263V15.0596C0.5 15.5198 0.873096 15.8929 1.33333 15.8929H15.0833C15.5436 15.8929 15.9167 15.5198 15.9167 15.0596V14.2263C15.9167 13.766 15.5436 13.3929 15.0833 13.3929Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58333 6.30789V13.3996M13.8333 6.30789V13.3996M10.2917 6.30789V13.3996M6.125 6.30789V13.3996M7.40833 0.704553L0.933333 4.24622C0.802194 4.31797 0.69277 4.42368 0.61653 4.55226C0.54029 4.68084 0.50004 4.82757 0.5 4.97705V5.80789C0.5 5.94049 0.552678 6.06767 0.646447 6.16144C0.740215 6.25521 0.867392 6.30789 1 6.30789H15.4167C15.5493 6.30789 15.6765 6.25521 15.7702 6.16144C15.864 6.06767 15.9167 5.94049 15.9167 5.80789V4.97705C15.9166 4.82757 15.8764 4.68084 15.8001 4.55226C15.7239 4.42368 15.6145 4.31797 15.4833 4.24622L9.00833 0.704553C8.76305 0.570343 8.48794 0.5 8.20833 0.5C7.92873 0.5 7.65362 0.570343 7.40833 0.704553Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.57606b8becba316f7d142e2e4e0de662.svg";
export { ForwardRef as ReactComponent };